import { decodeStorage } from 'functions/storageBase64';
import React from 'react';
import { BASE_PATH_PORTAL } from '../../../constants/general';

export function HeaderPromo() {

    const hostName = window.location.origin;
    const profileData = decodeStorage('profileData');

    return (
        <nav className="promoHeader">
            <ul>
                <li><a href={`${BASE_PATH_PORTAL}/credito-claroshop/beneficios`} className="bgRed">Mi Crédito Claroshop</a></li>

                <li><a href={`${BASE_PATH_PORTAL}/c/ofertas/`} className="fontYellow" >Ofertas</a></li>
                <li><a href={`${BASE_PATH_PORTAL}/categoria/21827/videojuegos/`}>Gamers</a></li>
                <li><a href={`${BASE_PATH_PORTAL}/categoria/21988/hasta-20--supermercado/pagina=1`} >Supermercado</a></li>
                <li><a href="https://blog.claroshop.com/" >Blog Claroshop</a></li>
            </ul>
        </nav>
    )
}